export default __webpack_public_path__ + "static/media/cards-img_mobile.c27b612c.png";